import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import StoreSocialMedia from "./StoreSocialMedia.js";
const StoreSocialMediaContainer = ({
  logos = [],
  socialMediaLinks = [],
  ...rest
}) => {
  const { getLabel } = useIntl();
  const labels = React.useMemo(
    () => ({
      title: getLabel("stores.page.details.socialMedia.title")
    }),
    [getLabel]
  );
  const items = React.useMemo(
    () => socialMediaLinks.map(({ code, url }) => {
      const logo = logos.find(({ image }) => image?.description === code);
      if (!logo) {
        return null;
      }
      return {
        name: code,
        url,
        iconUrl: logo.image?.url
      };
    }).filter((item) => item !== null),
    [logos, socialMediaLinks]
  );
  return items.length > 0 ? /* @__PURE__ */ React.createElement(StoreSocialMedia, { ...rest, labels, items }) : null;
};
export {
  StoreSocialMediaContainer as default
};
//# sourceMappingURL=StoreSocialMediaContainer.js.map
